"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _reactHookForm = require("react-hook-form");

var _messaging = require("../../../constants/messaging.types");

var CaptureWithTextAction = function CaptureWithTextAction(_ref) {
  var control = _ref.control,
      name = _ref.name,
      label = _ref.label,
      textFieldName = _ref.textFieldName,
      resetField = _ref.resetField;
  var checkboxControllerName = "".concat(_messaging.MessagingDataFields.RecipientActions, ".").concat(name);
  var textFieldControllerName = "".concat(_messaging.MessagingDataFields.RecipientActions, ".").concat(textFieldName);

  var _useController = (0, _reactHookForm.useController)({
    control,
    name: checkboxControllerName
  }),
      _useController$field = _useController.field,
      checkboxValue = _useController$field.value,
      onCheckboxChange = _useController$field.onChange;

  var _useController2 = (0, _reactHookForm.useController)({
    control,
    name: textFieldControllerName
  }),
      _useController2$field = _useController2.field,
      textFieldValue = _useController2$field.value,
      onTextFieldChange = _useController2$field.onChange,
      error = _useController2.fieldState.error;

  var isTextFieldEmpty = !textFieldValue;
  (0, _react.useEffect)(function () {
    if (!checkboxValue && !isTextFieldEmpty) {
      resetField(textFieldControllerName, {
        defaultValue: null
      });
    }
  }, [checkboxValue, resetField, textFieldControllerName, isTextFieldEmpty]);
  return /*#__PURE__*/_react.default.createElement(_material.FormControl, {
    error: !!(error !== null && error !== void 0 && error.message)
  }, /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
    checked: checkboxValue,
    onChange: function onChange(_, checked) {
      return onCheckboxChange(checked);
    },
    control: /*#__PURE__*/_react.default.createElement(_material.Checkbox, {
      color: "primary"
    }),
    label: /*#__PURE__*/_react.default.createElement(_material.FormLabel, null, label)
  }), /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    in: checkboxValue,
    mountOnEnter: true,
    unmountOnExit: true
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    ml: 4
  }, /*#__PURE__*/_react.default.createElement(_material.TextField, {
    error: !!(error !== null && error !== void 0 && error.message),
    helperText: error === null || error === void 0 ? void 0 : error.message,
    multiline: true,
    fullWidth: true,
    variant: "outlined",
    rows: 4,
    value: textFieldValue,
    onChange: function onChange(event) {
      return onTextFieldChange(event.target.value.trimLeft());
    }
  }))));
};

var _default = CaptureWithTextAction;
exports.default = _default;